import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../../actions/reportAction';
import * as orderAction from './../../../../../../actions/orderAction';
import SaleReportsByOrder from './SaleReportsByOrder';

const mapStateToProps = state => {
    return {
        reportState: state.reportReducer,
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSaleReportByOrder: (filters) => dispatch(reportAction.getSaleReportByOrder(filters)),
        exportExcel: filters => dispatch(orderAction.exportExcel(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SaleReportsByOrder));
